import {
  Sparkles,
  ArrowRight,
  ShieldCheck,
  Leaf,
  Zap,
  Star,
  Flame,
  Loader2,
} from "lucide-react";

import { useEffect, useState, useCallback } from "react";

import API from "../../services/api";

import bg from "../../assets/bg.png";
import "../../styles/hero-catalog.css";

const MEDIA_URL =
  process.env.REACT_APP_MEDIA_URL ||
  window.location.origin;

export default function HeroCatalog() {
  const [featuredProduct, setFeaturedProduct] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const normalizeImage = (image) => {
    if (!image) return null;

    if (
      image.startsWith("http://") ||
      image.startsWith("https://")
    ) {
      return image;
    }

    return `${MEDIA_URL}${image}`;
  };

  const loadFeaturedProduct =
    useCallback(async () => {
      try {
        setLoading(true);

        const response =
          await API.get("/products/");

        const products =
          response?.data?.results ||
          response?.data?.products ||
          response?.data?.data?.products ||
          response?.data?.data ||
          response?.data ||
          [];

        const productList =
          Array.isArray(products)
            ? products
            : [];

        const featured =
          productList.find(
            (p) =>
              p.is_featured === true
          ) || productList[0];

        if (featured) {
          setFeaturedProduct({
            ...featured,

            image:
              normalizeImage(
                featured.image
              ) ||
              normalizeImage(
                featured.image_url
              ),

            price: Number(
              featured.price || 0
            ),
          });
        }
      } catch (error) {
        console.error(
          "Error cargando producto destacado",
          error
        );
      } finally {
        setLoading(false);
      }
    }, []);

  useEffect(() => {
    loadFeaturedProduct();
  }, [loadFeaturedProduct]);

  return (
    <section
      className="hero-catalog"
      style={{
        backgroundImage: `url(${bg})`,
      }}
    >
      <div className="hero-overlay" />
      <div className="hero-smoke" />
      <div className="hero-blur hero-blur-1" />
      <div className="hero-blur hero-blur-2" />
      <div className="hero-grid" />

      <div className="hero-content">
        <div className="hero-tag">
          <Sparkles />
          <span>DEBUTS CROP • CULTURA PREMIUM 2026</span>
        </div>

        <h1>
          La evolución de la
          <span> cultura cannábica</span>
        </h1>

        <p className="hero-quote">
          No seguimos tendencias.
          <br />
          Creamos el nuevo estándar.
        </p>

        <p>
          En Debuts Crop reunimos las mejores marcas,
          tecnología de última generación y una
          selección premium para quienes entienden
          que la calidad no es un lujo, sino el punto
          de partida.

          Somos mucho más que un Grow Shop o un
          Smoke Shop. Somos el lugar donde la cultura
          cannábica evoluciona.
        </p>

        <div className="hero-features">

      <div className="feature">
        <ShieldCheck />
        <span>Productos Seleccionados</span>
      </div>

      <div className="feature">
        <Leaf />
        <span>Experiencia Premium</span>
      </div>

      <div className="feature">
        <Zap />
        <span>Innovación Constante</span>
      </div>

      <div className="feature">
        <Flame />
        <span>Marcas Exclusivas</span>
      </div>

    </div>

        <div className="hero-buttons">
          <button className="btn-primary">
            Descubrir la colección
            <ArrowRight />
          </button>

          <button className="btn-secondary">
            Conocer la experiencia
          </button>

          <button className="btn-secondary">
            Ver ofertas
          </button>
        </div>

        <div className="hero-stats">
          <div className="stat">
            <h3>+5K</h3>
            <span>Clientes</span>
          </div>

          <div className="stat">
            <h3>Premium</h3>
            <span>Productos</span>
          </div>

          <div className="stat">
            <h3>24/7</h3>
            <span>Soporte</span>
          </div>
        </div>
      </div>

      <div className="hero-floating-card">
        <div className="floating-light" />

        <span className="floating-badge">
          <Star />
          TOP PRODUCT
        </span>

        {loading ? (
          <div
            style={{
              height: "500px",
              display: "flex",
              justifyContent:
                "center",
              alignItems: "center",
            }}
          >
            <Loader2
              size={40}
              className="spin"
            />
          </div>
        ) : featuredProduct ? (
          <>
            <div className="floating-image">
              <img
                src={
                  featuredProduct.image
                }
                alt={
                  featuredProduct.name
                }
              />

              <div className="floating-image-overlay" />
            </div>

            <div className="floating-info">
              <small>
                {
                  featuredProduct.category
                }
              </small>

              <h3>
                {featuredProduct.name}
              </h3>

              <p>
                {featuredProduct.description ||
                  "Producto premium disponible en nuestro catálogo."}
              </p>

              <div className="floating-bottom">
                <span>
                  $
                  {featuredProduct.price.toLocaleString()}
                </span>

                <button>
                  Comprar
                </button>
              </div>
            </div>
          </>
        ) : (
          <div
            style={{
              padding: "30px",
              textAlign: "center",
            }}
          >
            No hay productos
            destacados
          </div>
        )}
      </div>
    </section>
  );
}